import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'invoices_json';

function loadInvoices() {
  const json = localStorage.getItem(LOCAL_KEY);
  if (json) {
    try {
      return JSON.parse(json);
    } catch {
      return [];
    }
  }
  return [];
}
function saveInvoices(invoices) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(invoices));
}

const initialState = {
  invoices: loadInvoices(),
  filtered: loadInvoices(),
  filters: {
    repId: '',
    clientId: '',
    status: '',
    dateFrom: '',
    dateTo: '',
  },
};

const invoiceSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    createInvoice(state, action) {
      state.invoices.push(action.payload);
      state.filtered = state.invoices;
      saveInvoices(state.invoices);
    },
    getRepInvoices(state, action) {
      state.filtered = state.invoices.filter(inv => inv.repId === action.payload);
    },
    getAllInvoices(state) {
      const latest = loadInvoices();
      state.invoices = latest;
      state.filtered = latest;
    },
    filterInvoices(state, action) {
      const latest = loadInvoices();
      state.invoices = latest;
      let filtered = latest;
      const { repId, clientId, status, dateFrom, dateTo } = action.payload;
      if (repId) filtered = filtered.filter(inv => inv.repId === repId);
      if (clientId) filtered = filtered.filter(inv => inv.clientId === clientId);
      if (status) filtered = filtered.filter(inv => inv.status === status);
      if (dateFrom) filtered = filtered.filter(inv => inv.date >= dateFrom);
      if (dateTo) filtered = filtered.filter(inv => inv.date <= dateTo);
      state.filtered = filtered;
    },
    deleteInvoice(state, action) {
      state.invoices = state.invoices.filter(inv => inv.id !== action.payload);
      state.filtered = state.invoices;
      saveInvoices(state.invoices);
    },
  },
});

export const { createInvoice, getRepInvoices, getAllInvoices, filterInvoices, deleteInvoice } = invoiceSlice.actions;
export default invoiceSlice.reducer; 